import React, { FC } from 'react';
import s from './collectionStats.module.scss';
import { useGetSingleCollection } from '@hooks/TRPC_Hooks/useGetSingleCollection';
import moment from 'moment';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
type CollectionStatsProps = {
  id: number;
};
export const CollectionStats: FC<CollectionStatsProps> = ({
  id
}) => {
  const {
    data: collection,
    isLoading
  } = useGetSingleCollection({
    id
  });
  if (isLoading) return <LogoLoader />;
  if (!collection) return null;
  return <div className={s.collectionStats} data-sentry-component="CollectionStats" data-sentry-source-file="CollectionStats.tsx">
            <div className={s.collectionStats__item}>
                <b>{moment(collection.created).format('DD.MM.YYYY')}</b>
                <span>Release</span>
            </div>
            <div className={s.collectionStats__item}>
                <b>{collection.toysTotal}</b>
                <span>Toys</span>
            </div>
        </div>;
};